// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3hUfy","approved":"Status_approved__2gYEW","rejected":"Status_rejected__2qiqY","expired":"Status_expired__bATrj","label":"Status_label__r8XlN"};